import * as React from "react";
import { ResetIcon } from "@radix-ui/react-icons";
import { toast } from "sonner";
import { useOptimisticUnArchiveItem } from "../common/hooks.ts";
import { ItemCard } from "../common/items/ItemCard.tsx";
import { ArchivedItemDoc } from "@repo/convex/convex/schema.ts";
import { ItemMenu } from "../common/items/ItemMenu.tsx";
import { TrashItemMenuItem } from "../common/items/menu/TrashItemMenuItem.tsx";
import { CommonMenuItems } from "../common/items/menu/CommonMenuItems.tsx";
import { CardIconButton, ItemActions } from "../common/items/ItemActions.tsx";
import { ItemNotesActionButton } from "../common/items/ItemNotesActionButton.tsx";
import { ListedItem } from "@repo/convex/convex/items.ts";
import { shortDate } from "../common/items/format.ts";

interface Props {
  item: ListedItem<ArchivedItemDoc>;
}

export const ArchiveItem: React.FC<Props> = ({ item }) => {
  const unarchive = useOptimisticUnArchiveItem();
  return (
    <ItemCard
      item={item}
      detail={`Tucked in ${shortDate(item.status.archivedAt)}`}
      actions={
        <ItemActions>
          {item.hasNotes ? <ItemNotesActionButton itemId={item._id} /> : null}
          <CardIconButton
            label="Back on the pile"
            onClick={() =>
              unarchive({ itemId: item._id })
                .then(() => toast.success("Back on the pile"))
                .catch(console.error)
            }
          >
            <ResetIcon />
          </CardIconButton>
        </ItemActions>
      }
      menu={
        <ItemMenu>
          <CommonMenuItems item={item} />
          <TrashItemMenuItem item={item} />
        </ItemMenu>
      }
    />
  );
};
